/**
 * Nasdaq 100 (NDX) component tickers — used to filter the S&P 500 universe
 * on the Stocks Overview page. No extra API calls needed since NDX ⊂ S&P 500 quotes.
 */
export const NASDAQ_100_TICKERS = new Set([
  'AAPL','MSFT','NVDA','AMZN','GOOG','GOOGL','META','TSLA','AVGO','COST',
  'NFLX','ASML','TMUS','AZN','CSCO','AMD','PEP','LIN','ADBE','TXN',
  'QCOM','ISRG','INTU','AMAT','AMGN','MU','HON','BKNG','VRTX','REGN',
  'PANW','ADP','LRCX','KDP','KLAC','SBUX','MDLZ','SNPS','CDNS','GILD',
  'CME','MELI','CTAS','INTC','PYPL','ABNB','CRWD','ORLY','NXPI','WDAY',
  'CEG','PCAR','FTNT','TTD','ROST','IDXX','ADSK','DXCM','MRVL','ODFL',
  'CPRT','BIIB','ZS','TEAM','FAST','VRSK','CHTR','ANSS','CSX','MAR',
  'PAYX','MNST','CTSH','GEHC','AEP','KHC','LULU','EA','EXC','XEL',
  'MRNA','ILMN','WBD','DLTR','ON','CCEP','ARM','DASH',
  'ROP','FANG','SMCI','CDW','TTWO','MCHP','DDOG','APP','PLTR','COIN',
]);
